import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Neo65 = () => (
  <ArticleWrapper articleId="neo65">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Neo65</h1>
        <img src="/pictures/gallery/gallery12.JPG" alt="Neo65" className="rounded-lg mb-6" />
        {/* Add your Neo65 article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default Neo65;
